/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import Switch from 'react-switch'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import UIkit from 'uikit'

// Components
import GenerateCertificate from 'app/views/components/GenerateCertificate'
import Icon from 'app/views/components/Icon'
import ModalSetUsername from 'app/views/components/Modals/ModalSetUsername'

// Redux
import { updateSendReminders, getHackerDetails, updateScratchpadStatus } from 'app/state/modules/hacker'
import { getRewards } from 'app/state/modules/rewards'
// Utils
import analytics from 'app/views/utils/analytics'
import ModalPreferLanguages from 'app/views/components/Modals/ModalPreferLanguages'

const propTypes = {
  license: PropTypes.bool,
}
const defaultProps = {
  license: false,
}

class Profile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sendReminders: typeof this.props.profile.send_reminders === 'boolean' ? this.props.profile.send_reminders : false,
      scratchpad: this.props.profile.settings.scratchpad && typeof this.props.profile.settings.scratchpad.enabled === 'boolean' ? this.props.profile.settings.scratchpad.enabled : false,
    }

    this.handleSendRemindersChange = this.handleSendRemindersChange.bind(this)
    this.renderRewards = this.renderRewards.bind(this)
    this.handleChangeScratchpadStatus = this.handleChangeScratchpadStatus.bind(this)
  }

  componentDidMount() {
    this.props.getRewards()
    analytics.page('page-profile')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.profile.send_reminders !== this.state.sendReminders) {
      this.setState({ sendReminders: nextProps.profile.send_reminders })
    }
    if (nextProps.profile.settings.scratchpad && typeof nextProps.profile.settings.scratchpad.enabled === 'boolean' && nextProps.profile.settings.scratchpad.enabled !== this.state.scratchpad) {
      this.setState({ scratchpad: nextProps.profile.settings.scratchpad.enabled })
    }
  }

  getLastCompletedDate(courses) {
    let lastCompletedDate = null
    courses.forEach((course) => {
      if (course.completed_at) {
        if (lastCompletedDate) {
          if (moment(course.completed_at).isAfter(lastCompletedDate)) {
            lastCompletedDate = course.completed_at
          }
        } else {
          lastCompletedDate = course.completed_at
        }
      }
    })
    return lastCompletedDate
  }

  handleChangeScratchpadStatus() {
    const enabled = this.props.profile.settings.scratchpad && typeof this.props.profile.settings.scratchpad.enabled === 'boolean' ? this.props.profile.settings.scratchpad.enabled : false
    this.props.updateScratchpadStatus(!enabled)
  }

  handleSendRemindersChange() {
    this.props.updateSendReminders(!this.props.profile.send_reminders)
  }

  renderRewards() {
    if (Object.values(this.props.rewardsByOrganization).length === 0) {
      return <p>You haven't claim any rewards yet.</p>
    }
    return Object.values(this.props.rewardsByOrganization).reduce((prev, curr) => {
      if (curr.claimedReward) {
        prev.push({
          claimed: curr.claimedReward.claimed,
          reward: curr.claimedReward.reward,
          delivered: curr.claimedReward.delivered
        })
      }
      return prev
    }, []).map((reward) => {
      let rewardType
      if (reward.reward.crypto) {
        rewardType = `You claimed ${parseFloat(reward.reward.crypto.currencyValue.amount).toFixed(2)} ${reward.reward.crypto.currencyValue.currency} Crypto (${reward.reward.crypto.asset}) on ${moment(reward.claimed.time).format('MMMM DD, YYYY')}`
      } else if (reward.reward.giftCard) {
        rewardType = `You claimed a ${parseFloat(reward.reward.giftCard.amount.amount).toFixed(2)} ${reward.reward.giftCard.amount.currency}  ${reward.reward.giftCard.name} Gift Card on ${moment(reward.claimed.time).format('MMMM DD, YYYY')}`
      }
      return (
        <div>
          <p className="uk-text-emphasis uk-margin-remove uk-text-small">
            {rewardType}
          </p>
          <small className="uk-text-italic">
            {reward.delivered && reward.delivered.time ? `Delivered on ${moment(reward.delivered.time).format('MMMM DD, YYYY')}` : 'Will be delivered soon'}
          </small>
        </div>
      )
    })
  }

  render() {
    return (
      <div data-test-id="profile-component" className="uk-background-muted" style={{ minHeight: 'calc(100vh - 80px)' }}>
        <div className="uk-section">
          <div className="uk-container">
            <div className="uk-child-width-expand@s" data-uk-grid>
              <div className="uk-width-1-3@m">
                <div data-test-id="username-manage-container" className="uk-card uk-card-default uk-card-body">
                  <div className="uk-text-center">
                    <Icon name="user" ratio={3.5} />
                  </div>
                  <h4>{this.props.profile.email}</h4>
                  {this.props.profile.username ? (
                    <div>
                      <p>
                        {this.props.profile.username}
                        &nbsp;
                        (
                        <Link data-test-id="change-username-btn" to="#" data-uk-toggle="#modal-set-username">
                          Change Username
                        </Link>
                        )
                      </p>
                    </div>
                  )
                    : (
                      <button
                        data-test-id="set-username-btn"
                        type="button"
                        className="uk-button uk-button-primary uk-button-small tm-button-primary"
                        data-uk-toggle="#modal-set-username"
                      >
                        Set a Username
                      </button>
                    )}
                </div>

                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>Communication Preferences</h4>
                  <div>
                    <input
                      data-test-id="reminders-checkbox"
                      className="uk-checkbox"
                      type="checkbox"
                      onChange={this.handleSendRemindersChange}
                      style={{ marginRight: 10 }}
                      checked={this.state.sendReminders}
                    />
                    <label htmlFor="proxy-intercept" className="uk-text-small uk-text-bold">
                      Receive Reminder Emails
                    </label>
                  </div>
                </div>

                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>User Settings</h4>
                  <div>
                    <div className="uk-inline">
                      <Switch
                        onChange={this.handleChangeScratchpadStatus}
                        checked={this.state.scratchpad}
                        width={52}
                        height={26}
                        id="normal-switch"
                        offColor="#999999"
                        onColor="#1e87f0"
                        checkedIcon={false}
                        uncheckedIcon={false}
                      />
                      <span style={{ paddingLeft: 10, verticalAlign: 'top' }}>
                        Scratchpad
                      </span>
                      <Icon
                        href="#"
                        type="button"
                        role="button"
                        name="information"
                        ratio={0.8}
                        onClick={(e) => {
                          e.preventDefault()
                          UIkit.modal.alert(`
                          <h2>Scratchpad</h2>
                          <p>
                            You can use the Scratchpad to take notes during lessons.
                            When enabled, the Scratchpad can be opened with the blue button on the bottom left of the lesson area.
                          </p>
                          `)
                        }}
                        style={{
                          cursor: 'pointer',
                          paddingLeft: 8,
                          paddingTop: 6,
                          verticalAlign: 'top',
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>Coding language preferences</h4>
                  <ModalPreferLanguages withButton id="profile-edit-prefered-language" />
                </div>
              </div>

              <div className="uk-width-2-3@m">
                <div className="uk-card uk-card-default uk-card-body">
                  {this.props.license === true ? (
                    <div>
                      <h4>Subscription</h4>
                      <p>
                        If you would like to cancel your subscription, email us at
                        {' '}
                        <a href="mailto:support@hackedu.com">support@hackedu.com</a>
                      </p>
                    </div>
                  )
                    : (
                      <div>
                        <h4>Subscription</h4>
                        <p>You do not have a HackEDU Subscription</p>
                        <Link to="/contact" className="uk-button uk-button-primary tm-button-primary">
                          Upgrade Now
                        </Link>
                      </div>
                    )}
                </div>

                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>Training</h4>
                  <div>
                    {this.props.profile.has_finished_training
                      && typeof this.props.profile.email === 'string' ? (
                      <GenerateCertificate
                        style={{ display: 'flex' }}
                        email={this.props.profile.email}
                        completionDate={this.props.profile.last_completed_at}
                        courseName={this.props.user.plan_title}
                        className="uk-button uk-button-default"
                      >
                        <Icon name="download-cloud" className="uk-margin-small-right" />
                        Generate Certificate
                      </GenerateCertificate>
                    ) : (
                      <p>You have not completed the OWASP Top 10 training plan</p>
                    )}
                  </div>
                </div>
                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>Rewards</h4>
                  {this.renderRewards()}
                </div>

              </div>
            </div>
          </div>
        </div>

        <ModalSetUsername />
      </div >
    )
  }
}

Profile.propTypes = propTypes
Profile.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  // hacker
  license: state.hacker.license,
  profile: state.hacker.profile,
  user: state.hacker.currentHackerDetails,
  rewardsByOrganization: state.rewards.rewardsByOrganization,
})
const mapDispatchToProps = (dispatch) => ({
  updateSendReminders: (sendReminders) => dispatch(updateSendReminders(sendReminders)),
  dispatchGetHackerDetails: (teamId, hackerId) => dispatch(getHackerDetails(teamId, hackerId)),
  updateScratchpadStatus: (enabled) => dispatch(updateScratchpadStatus(enabled)),
  getRewards: (cb) => dispatch(getRewards(cb)),
})
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile)
